import type { PayloadAction } from '@reduxjs/toolkit'
import type { AppState } from '../slices/appSlice'

export const setFullScreen = (state: AppState, action: PayloadAction<boolean>) => {
  state.isFullScreen = action.payload
}

export const setDarkMode = (state: AppState, action: PayloadAction<boolean>) => {
  state.isDarkMode = action.payload
}

export const setEnglish = (state: AppState, action: PayloadAction<boolean>) => {
  state.isEnglish = action.payload
}

export const setUtc = (state: AppState, action: PayloadAction<boolean>) => {
  state.isUtc = action.payload
}
